import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CookieInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isMultipart = request.url.toLocaleLowerCase().includes('/file');
    const headers: any = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Method': 'GET,POST,OPTIONS,DELETE,PUT,PATCH',
      Accept: 'application/json',

    };
    if (!isMultipart) {
      headers['Content-Type'] = 'application/json; charset=utf-8';
    }

    request = request.clone({
      withCredentials: true,
      setHeaders: headers
    });
    return next.handle(request);
  }
}
